/* eslint-disable max-len */
import { Component } from '@angular/core'


@Component({
  selector: 'se-po-persona-info-docs',
  templateUrl: './persona-info-docs.component.html',
  styleUrls: ['./persona-info-docs.component.scss'],
  standalone: false,
})
export class PersonaInfoDocsComponent {
  public models: string[]
  public headers: any = {
    PersonaInfoComponent: [
      'Property',
      'Type',
      'Description',
    ],
    PersonaInfoLabels: [
      'Property',
      'Type',
      'Description',
    ],
    PersonaInfo: [
      'Property',
      'Type',
      'Description',
    ],
    PersonaInfoName: [
      'Property',
      'Type',
      'Description',
    ]
  }
  public rows: any = {
    PersonaInfoComponent: [
      {
        Property: '@Input() labels?',
        Type: 'PersonaInfoLabels',
        Description: 'Map of overrides for default field labels (all optional: name, gender, dateOfBirth, gradYear)',
      },
      {
        Property: '@Input() optionalFields?',
        Type: 'string[]',
        Description: 'List of fields to include as optional (all fields except gradYear are enabled by default. All enabled fields except name are optional by default)',
      },
      {
        Property: '@Input() requiredFields?',
        Type: 'string[]',
        Description: 'List of fields to include as required (all fields except gradYear are enabled by default. All enabled fields except name are optional by default)',
      },
      {
        Property: '@Input() accountAgeRequired?',
        Type: 'boolean',
        Description: 'Will require age over 13 for account creation, and include tooltips about why.',
      },
    ],
    PersonaInfoLabels: [
      {
        Property: 'name',
        Type: 'string',
        Description: 'Label for Name (default="Participant\'s Full Name")'
      },
      {
        Property: 'gender',
        Type: 'string',
        Description: 'Label for Gender (default="Participant Gender")'
      },
      {
        Property: 'dateOfBirth',
        Type: 'string',
        Description: 'Label for Date of Birth (default="Birthday")'
      },
      {
        Property: 'gradYear',
        Type: 'string',
        Description: 'Label for Date of Grad Year (default="Graduation Year")'
      },
    ],
    PersonaInfo: [
      {
        Property: 'addresses?',
        Type: 'UserServiceResources.Address[]',
        Description: 'Addresses - usually just 1'
      },
      {
        Property: 'dateOfBirth',
        Type: 'string',
        Description: 'Birthdate of the persona',
      },
      {
        Property: 'email?',
        Type: 'string',
        Description: 'Email Address of the persona',
      },
      {
        Property: 'gender',
        Type: 'string',
        Description: 'Gender of the persona',
      },
      {
        Property: 'gradYear',
        Type: 'string',
        Description: 'Graduation Year of the persona',
      },
      {
        Property: 'name',
        Type: 'PersonaInfoName',
        Description: 'Full Name of the persona',
      },
      {
        Property: 'phone?',
        Type: 'string',
        Description: 'Phone Number of the persona',
      },
    ],
    PersonaInfoName: [
      {
        Property: 'first',
        Type: 'string',
        Description: 'First Name',
      },
      {
        Property: 'last',
        Type: 'string',
        Description: 'Last Name',
      },
      {
        Property: 'preferred?',
        Type: 'string',
        Description: 'Nickname',
      },
      {
        Property: 'suffix?',
        Type: 'string',
        Description: 'Name Suffix (Jr., Sr., II, III, etc.)',
      },
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
